import React from 'react'
import styles from '../../styles/common.module.css';

interface SectionTitleSubProps {
    content: String;
    contentEng: String;
}

const SectionTitleSub: React.FC<SectionTitleSubProps> = ({ content, contentEng }) => {
    return (
        <div className={styles.contentS}>
            <p>{content}</p>
            <span>{contentEng}</span>
        </div>
    )
}


export default SectionTitleSub;
